import Swiper from 'swiper';
import { Manipulation, Navigation, Pagination, Zoom, Thumbs } from 'swiper/modules';

export default function setGallery(Product) {
  const thumbs = new Swiper(Product.thumbsSlider.element, {
    modules: [Manipulation],
    direction: 'horizontal',
    slidesPerView: 4,
    spaceBetween: 20,
    speed: 1000,
    watchSlidesProgress: true,
    watchOverflow: true,
    preloadImages: false,
  });

  const main = new Swiper(Product.mainSlider.element, {
    modules: [Manipulation, Navigation, Pagination, Zoom, Thumbs],
    slidesPerView: 2,
    speed: 1000,
    spaceBetween: 20,
    watchOverflow: true,
    watchSlidesProgress: true,
    thumbs: {
      swiper: thumbs,
    },
    navigation: {
      nextEl: '[data-main-slider] .swiper-button-next',
      prevEl: '[data-main-slider] .swiper-button-prev',
    },
    pagination: {
      el: '[data-product-images] .swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    preloadImages: false,
    zoom: {
      maxRatio: 1.5,
      zoomedSlideClass: '-zoomed',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        pagination: false
      },
      768: {
        slidesPerView: 2
      }
    }
  });

  Product.thumbsSlider.swiper = thumbs;
  Product.mainSlider.swiper = main;

  // document.querySelectorAll("[data-main-slider] .swiper-slide").forEach((item) => {
  //   item.addEventListener('mouseover', () => {
  //     main.zoom.in()
  //   })
  //   item.addEventListener('mouseout', () => {
  //     main.zoom.out()
  //   })
  // })
}
